var BACKEND = BACKEND || (function () {
    'use strict';

    var saveForm = function () {
        var elementsSubmit = $('.element-submit').not('.disabled');
        var length = elementsSubmit.length;
        if (length) {
            var completed = 0;
            var firstError = false;
            elementsSubmit.each(function (i) {
                var elementCounter = $(this).data('element-counter');
                var containerId = '#' + elementCounter + '-container';
                // var successId = '#' + elementCounter + '-success';
                $(containerId).find('#Element_collapse').val($('#elements-block-' + elementCounter).hasClass('opened') ? '1' : '0');
                $.ajax({
                    url: '/be/element/update/json/true',
                    type: 'POST',
                    data: new FormData(document.getElementById(elementCounter + '-form')),
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        completed++;
                        data = $.parseJSON(data);
                        if (data.error && firstError === false) {
                            firstError = containerId;
                        }
                        $(containerId).replaceWith(data.html);
                        // $(successId).fadeTo(2000, 500);
                        if (completed == length) {
                            elementsFormsSaved(firstError);
                        }
                    },
                });
            });
        } else {
            $('#horizontalForm').submit();
        }
    };

    var elementsFormsSaved = function (error) {
        $('#elements-block').trigger('sortupdate');
        if (error) {
            var container = $(error);
            var defaultOffset = 110;
            $('html, body').animate({
                scrollTop: container.offset().top - defaultOffset
            }, 600);
        } else {
            $('#horizontalForm').submit();
        }
    };

    var updateTabsLanguage = function () {
        var uid = $('#page-wrapper').data('uid');
        var storageLabel = uid != undefined ? uid + '-tab_language' : 'tab_language';
        var currentTabLanguage = $.jStorage.get(storageLabel);
        $('.nav-tabs a[href$="_tab_' + currentTabLanguage + '"]').tab('show');

        $(document).on('click', '.nav-tabs a', function () {
            var languageId = $(this).data('language-id');
            $('.nav-tabs a[href$="_tab_' + languageId + '"]').tab('show');
            $.jStorage.set(storageLabel, languageId);
        });
    };

    $(window).on('load', function () {
        $('.spinner').animate({
            opacity: 0
        }, 10, 'easeOutCubic', function () {
            $(this).css('display', 'none');
            $('#content').removeClass('hidden');
        });

        // $('.box.hidden').remove();

        updateTabsLanguage();
    });

    $(window).on('load resize', function () {
        var pageEditHeader = $('#page-edit-header');
        var pageEditActions = $('#page-edit-actions');
        var pageEditHeaderHeight;
        pageEditActions.insertAfter('#page-edit-title');

        if ($(window).width() > 768) {
            pageEditHeaderHeight = pageEditHeader.outerHeight();
            var content = $('#content');
            content.css('padding-top', pageEditHeaderHeight + 30 + 'px');
            if (pageEditActions.length > 0) {
                pageEditHeaderHeight = pageEditHeader.outerHeight();
                content.css('padding-top', pageEditHeaderHeight + 30 + 'px');
            }
        }
    });

    // $(window).on('ajaxComplete', function () {
    //     setTimeout(function () {
    //         $(window).lazyLoadXT();
    //     }, 50);
    // });

    // if ($.lazyLoadXT) {
    //     $.lazyLoadXT.onload = function () {
    //         var $el = $(this);
    //         $el.removeClass('lazy-hidden').addClass('animated ' + 'fadeIn');
    //     };
    //     $.lazyLoadXT.loadEvent = 'pageshow ajaxComplete';
    // }


    $(document).ready(function () {

        $('[data-toggle="tooltip"]').tooltip();

        var $affixElement = $('div[data-spy="affix"]');
        $affixElement.width($affixElement.parent().width());

        setTimeout(function () {
            $('.alert').not('.alert-stuck').fadeOut('fast');
            // $('.alert-danger').fadeOut(8000);
        }, 8000);

        webshim.setOptions('forms', {
            lazyCustomMessages: true,
            replaceValidationUI: true
        });
        webshim.polyfill('forms');

        $('[type="submit"]').not('.dropdown-toggle').not('.disabled').click(function () {
            var btn = $(this);
            $(btn).buttonLoader('start');
            setTimeout(function () {
                $(btn).buttonLoader('stop');
            }, 4000);
        });

        if ($('#btn-save').length > 0 || $('.btn-save-simple').length > 0) {
            $(document).keydown(function (e) {
                var key = undefined;
                var possible = [e.key, e.keyIdentifier, e.keyCode, e.which];

                while (key === undefined && possible.length > 0) {
                    key = possible.pop();
                }

                if (key && (key == '115' || key == '83') && (e.ctrlKey || e.metaKey) && !(e.altKey)) {
                    e.preventDefault();
                    $('#btn-save').click();
                    $('.btn-save-simple').click();

                    return false;
                }

                return true;
            });
        }

        $('.popover-help').popover({
            trigger: 'hover',
            delay: 500,
            html: true
        });

        $('.brand').attr('target', '_blank');

        $('input').attr('autocomplete', 'off');

        if ($('#side-menu').length) {
            $('#side-menu').metisMenu();
        }

        // PAGE AND GALLERY SETTINGS //
        $('#page-settings .dropdown-menu input, #page-settings .dropdown-menu label').on('click', function (e) {
            e.stopPropagation();
        });
        $('.js-btn-side-panel').on('click', function (event) {
            event.preventDefault();
            var dataTarget = $(this).data('target');
            $('#'+dataTarget).addClass('is-visible');
            if(!$(this).hasClass('js-btn-seo-check')) {
                $('.overlay').addClass('overlay-on');
                $('body').addClass('open-sd');
            }
        });

        $('.js-btn-seo-check').on('click', function() {
            if($('#collapseMainContentTips[aria-expanded=false]')) {
                $('body').toggleClass('show-tips');
            }
        });
        //close the lateral panel
        $('.cd-panel, .side-panel').on('click', function (event) {
            if ($(event.target).is('.cd-panel') ||
            $(event.target).is('.cd-panel-close') ||
            $(event.target).is('.side-panel') ||
            $(event.target).is('.side-panel-close')
            ) {
                event.preventDefault();
                $('.cd-panel, .side-panel').removeClass('is-visible');
                $('.overlay').removeClass('overlay-on');
                $('body').removeClass('open-sd');
            }
        });
        // disable input disabled
        $('.cd-panel-content input').each(function () {
            var input = $(this);
            if (input.is('[disabled=disabled]')) {
                input.parent().css('color', '#ccc');
            }
        });
        // *** //

        // SAVE BUTTONS
        $(document).on('click', '.save-link', function (event) {
            event.preventDefault();

            if ($(this).attr('id') == 'save-and-exit') {
                $('[id$=\"_saveActions\"]').val(1)
            }
            if ($(this).attr('id') == 'save-and-new') {
                $('[id$=\"_saveActions\"]').val(2)
            }

            saveForm();
        });

        $(document).on('click', '#btn-save', function (event) {
            event.preventDefault();

            saveForm();
        });

        $('.h1-tips').parent('.input-group').addClass('h1-tips-group');

        $('a.smoothscroll').click(function () {
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    var offset = target.offset().top;
                    var defaultOffset = 110;
                    if ($(this).attr('data-offset')) {
                        offset = offset + $(this).data('offset');
                    } else {
                        offset = offset - defaultOffset;
                    }
                    $('html, body').animate({
                        scrollTop: offset
                    }, 1000);
                    return false;
                }
            }
        });
        $('.password-toggle').on('click', function () {
            if ($('#UserLogin_password').hasClass('showed')) {
                $('#UserLogin_password').attr('type', 'password').removeClass('showed');
                $(this).html('<i class="fa fa-eye"></i>');
            } else {
                $('#UserLogin_password').attr('type', 'text').addClass('showed');
                $(this).html('<i class="fa fa-eye-slash"></i>');
            }
        });

        if($('.timeago').length > 0) {
            jQuery.timeago.settings.allowFuture = true;
            $('.timeago').timeago();
        }

        $('.box').each(function () {
            if (!($(this).find('.box-inner').children().length > 0)) {
                $(this).addClass('hidden');
            }
        });

        if (typeof CodeMirror !== "undefined") {
            var editor = CodeMirror.fromTextArea(document.getElementById("Settings_custom_css"), {
                "lineNumbers": true,
                "lint": true,
                "indentUnit": 4,
                "indentWithTabs": true,
                "gutters": ["CodeMirror-lint-markers"],
                "autoCloseBrackets": true
            });
        }

        updateSearchFilters();
        searchFiltersHandlers();
        collpaseCards();

    });

    var updateSearchFilters = function() {
        if ($.jStorage) {
            $('.btn-search').each(function () {
                var dataId = $(this).data('id');
                var gridvewId = $(this).data('gridview-id');
                if (gridvewId) {
                    var filters = $('#'+gridvewId).find('.filters');
                } else {
                    var filters = $('.filters:first');
                }
                var value = $.jStorage.get(dataId);
                if (!value || value === 'hidden') {
                    filters.removeClass('opened');
                    $(this).removeClass('opened');
                    $('.btn-search-reset').addClass('hidden');
                } else {
                    filters.addClass('opened');
                    $(this).addClass('opened');
                    $('.btn-search-reset').removeClass('hidden');
                }
            });
        }
    };

    var searchFiltersHandlers = function () {
        $(document).on('click', '.btn-search', function (e) {
            e.preventDefault();
            var dataId = $(this).data('id');
            var gridvewId = $(this).data('gridview-id');
            var filters = gridvewId ? $('#' + gridvewId).find('.filters') : $('.filters:first');

            $('.btn-search').toggleClass('opened');

            if ($('.btn-search').hasClass('opened')) {
                filters.addClass('opened');
                $('.btn-search-reset').removeClass('hidden');
                $.jStorage.set(dataId, 'show');
            } else {
                filters.removeClass('opened');
                $('.btn-search-reset').addClass('hidden');
                $.jStorage.set(dataId, 'hidden');
            }
        });

        $(document).on('click', '.btn-search-reset', function (e) {
            e.preventDefault();
            location.reload();
        });
    }

    var collpaseCards = function() {
        if ($.jStorage) {
            $('.card-body').not('.element-body').each(function (i) {
                var dataId = $(this).attr('id');
                if (dataId) {
                    var dataTargetId = '#' + dataId;
                    var value = $.jStorage.get(dataTargetId);
                    var $collapse = $(this).prev().find('[data-action="collapse"]');
                    if (value && value === 'hidden') {
                        $(dataTargetId).hide().removeClass('opened');
                        $collapse.parent('.list-icons').find('.btn-add').addClass('hidden');
                        $collapse.parent('.list-icons').find('.btn-tips').addClass('hidden');
                        $collapse.parent('.list-icons').find('.js-btn-side-panel').addClass('hidden');
                        $collapse.addClass('fa-chevron-down').removeClass('fa-chevron-up');
                    } else {
                        $(dataTargetId).show().addClass('opened');
                        $collapse.parent('.list-icons').find('.btn-add').removeClass('hidden');
                        $collapse.parent('.list-icons').find('.btn-tips').removeClass('hidden');
                        $collapse.parent('.list-icons').find('.js-btn-side-panel').removeClass('hidden');
                        $collapse.removeClass('fa-chevron-down').addClass('fa-chevron-up');
                    }
                }
            });

            $('.element-body').each(function (i) {
                var dataItem = $(this).data('item');
                if (dataItem) {
                    var dataId = $(this).attr('id');
                    var dataTargetId = '#' + dataId;
                    var sortedCollapse = $.jStorage.get(dataItem);
                    if (sortedCollapse) {
                        var value = sortedCollapse[i];
                        var $collapse = $(this).prev().find('[data-action="collapse"]');
                        if (value && value === 'hidden') {
                            $(dataTargetId).hide().removeClass('opened');
                            $collapse.addClass('fa-chevron-down').removeClass('fa-chevron-up');
                        } else {
                            $(dataTargetId).show().addClass('opened');
                            $collapse.removeClass('fa-chevron-down').addClass('fa-chevron-up');
                        }
                    }
                }
            });

            $(document).on('click', '[data-action="collapse"]', function (e) {
                e.preventDefault();
                var dataTarget = $(this).data('target');
                var isElement = $(this).hasClass('element-collapse');

                if (dataTarget) {
                    var dataTargetId = '#' + dataTarget;
                    if ($(dataTargetId).hasClass('opened')) {
                        $(dataTargetId).removeClass('opened').slideUp();
                        if (!isElement) {
                            $.jStorage.set(dataTargetId, 'hidden');
                        }
                    } else {
                        $(dataTargetId).addClass('opened').slideDown();
                        if (!isElement) {
                            $.jStorage.set(dataTargetId, 'show');
                        }
                    }
                    $(this).toggleClass('fa-chevron-down fa-chevron-up');
                    $(this).parent('.list-icons').find('.btn-add').toggleClass('hidden');
                    $(this).parent('.list-icons').find('.btn-tips').toggleClass('hidden');
                    $(this).parent('.list-icons').find('.js-btn-side-panel').toggleClass('hidden');
                }

                if (isElement) {
                    var sortedCollapse = [];
                    var elements = $('[id^=\'elements-block-\']');
                    if (elements.length) {
                        var storageKey = elements.first().data('item');
                        elements.each(function (index) {
                            storageKey = $(this).data('item');
                            sortedCollapse.push($(this).hasClass('opened') ? 'show' : 'hidden');
                        });
                        $.jStorage.set(storageKey, sortedCollapse);
                    }
                }
            });
        }
    };

    return {
        searchFilters: updateSearchFilters,
        updateTabsLanguage: updateTabsLanguage,
    };
}());
